module.exports = __webpack_public_path__ + "static/media/House.fc512720.svg";